import { useSelector } from 'react-redux';
import { isMobile } from 'components/Shared/responsive';
import Image from 'components/Shared/Image';
import { hasElements, NO_ELEMENT } from 'utils';
import { Cell, Grid } from 'components/Grid';
import { KnowledgebaseMenuItem } from 'models/KnowledgebaseMenuItem';
import styles from './subArticles.scss';

interface Props {
  title?: string;
  text?: string;
  articles?: KnowledgebaseMenuItem[];
  showBody: boolean;
}

interface ArticleProps {
  article: KnowledgebaseMenuItem;
  showBody: boolean;
}

const SIZE_MOBILE = {
  height: 288,
  width: 560
};
const SIZE = {
  height: 400,
  width: 800
};

const MAX_BODY_LENGHT = 100;

const CropBody = (body: string) => {
  if (body === undefined || body?.length <= MAX_BODY_LENGHT) {
    return body;
  }

  const cropped = body.substr(0, MAX_BODY_LENGHT);

  return `${cropped.substr(0, cropped.lastIndexOf(' '))}...`;
};

const Article = ({ article, showBody }: ArticleProps) => {
  const mobile = useSelector(isMobile);

  return (
    <Cell key={article.url}>
      <a className={styles.article} href={article.url}>
        <div className={styles.image}>
          {article.image ? (
            <Image {...article.image} {...(mobile ? SIZE_MOBILE : SIZE)} />
          ) : (
            <div />
          )}

          <h3 className={styles.title}>{article.name}</h3>
        </div>
        {showBody && (
          <div className={styles.body}>
            {CropBody(article.shortBody?.length > 0 ? article.shortBody : article.body)}
          </div>
        )}
      </a>
    </Cell>
  );
};

export const SubArticles = ({ title, text, articles, showBody }: Props) => {
  if (!hasElements(articles)) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.articles}>
      {title && <h2 className={styles.header}>{title}</h2>}
      {text && <p className={styles.text}>{text}</p>}
      <Grid phone="1" tablet="2" desktop="3" gutters="extraLarge">
        {articles.map(a => (
          <Article key={a.url} article={a} showBody={showBody} />
        ))}
      </Grid>
    </div>
  );
};
